import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import Breadcrumb from "../components/site/Breadcrumb";

export default function Gallery() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.products().then(setProducts);
  }, []);

  return (
    <div>
      <section className="bg-[#F8FAF8] border-b border-[#E2E8E4] pt-12 pb-14">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <Breadcrumb items={[{ label: "Gallery" }]} />
          <h1 className="font-head text-4xl md:text-6xl font-medium tracking-tighter text-[#0A1C0E] mt-6">
            Gallery
          </h1>
          <p className="text-lg text-[#3A4D3E] mt-3 max-w-xl">
            A look at our packaging range in action.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="columns-2 md:columns-3 lg:columns-4 gap-5 space-y-5">
            {products.map((p, i) => (
              <motion.div
                key={p.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: (i % 6) * 0.05 }}
                className="break-inside-avoid rounded-2xl overflow-hidden border border-[#E2E8E4] group relative"
                data-testid={`gallery-item-${p.slug}`}
              >
                <img src={p.image} alt={p.name} loading="lazy" className="w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1C0E]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                  <span className="text-white font-head font-semibold">{p.name}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
